import React from 'react'

import * as styles from './PrivacyPolicyPage.m.css'

const PrivacyPolicyPage: React.FC = (): React.ReactElement => {
  return (
    <div className={styles.privacyPolicy}>
      <h2>Privacy Policy</h2>

      <p>
        At Performance Pro Supply, we value your privacy and are committed to
        protecting your personal information. This Privacy Policy explains how
        we collect, use, store, and share your information when you access our
        customer invoicing and payment portal.
      </p>

      <p>
        Performance Pro Supply collects, uses, and stores information provided
        as needed to enable customers to view and pay current and past invoices
        through this portal. We do not directly store any credit card or
        financial institution account information. We partner with Stripe, a
        global payment processing leader. Any financial account information
        provided is managed and secured by their systems and is subject to their
        privacy policy.{' '}
        <a href="https://stripe.com/privacy">https://stripe.com/privacy</a>
      </p>

      <h2>Contact forms</h2>

      <p>
        Along with the contact form submission, the time, date, and user-agent
        string from your browser will be collected to assist in troubleshooting
        any issues.
      </p>

      <h2>Cookies</h2>

      <p>
        If you visit our login page, we will set a temporary cookie to determine
        if your browser accepts cookies. This cookie contains no personal data
        and is discarded when you close your browser.
      </p>

      <p>
        When you log in, we will also set up several cookies to save your login
        and session information. Session cookies last for seven days. If you log
        out of your account, the login cookies will be removed.
      </p>

      <h2>Sharing Your Information</h2>

      <p>We may share your data with:</p>

      <ul>
        <li>
          <strong>Trusted Service Providers</strong>: such as payment processors
          or hosting providers, solely to provide our services. All third
          parties are required to maintain the confidentiality and security of
          your data.
          <br />
          <br /> We use <strong>Stripe</strong> for identity document
          verification. Stripe collects identity document images, facial images,
          ID numbers and addresses as well as advanced fraud signals and
          information about the devices that connect to its services. Stripe
          shares this information with us as well as uses this information to
          operate and improve the services it provides, including for fraud
          detection. You may also choose to allow Stripe to use your data to
          improve Stripe's biometric verification technology. You can learn more
          about Stripe and read its privacy policy at
          <a href="https://stripe.com/privacy">https://stripe.com/privacy</a>.
        </li>

        <li>
          Regulatory or Legal Authorities: When required by law, subpoena, or
          court order.
        </li>
      </ul>

      <h2>Your Rights and Choices</h2>

      <p>
        If you have an account on this site, you can request that we update or
        erase any personal data we hold about you. This does not include any
        data we are obliged to keep for administrative, legal, or security
        purposes.
      </p>

      <h2>Policy Updates</h2>

      <p>
        We may update this Privacy Policy periodically. The latest version will
        always be available at{' '}
        <a href="https://portal.performanceprosupply.com/privacy">
          https://portal.performanceprosupply.com/privacy
        </a>
        . We encourage you to review it regularly to stay informed.
      </p>
    </div>
  )
}

export default PrivacyPolicyPage
